import Vue from "vue";
import Router from "vue-router";
import Bio from "@/components/Bio";
import Home from "@/components/Home";
import About from "@/components/About";
import Kontakt from "@/components/Kontakt";
import Leistungen from "@/components/Leistungen";
import Methoden from "@/components/Methoden";
import Termine from "@/components/Termine";
import Neuro from "@/components/Neuro";
import Newsletter from "@/components/Newsletter";
import Impressum from "@/components/Impressum";
import Agb from "@/components/Agb";
import Teilnahmebedingungen from "@/components/Teilnahmebedingungen";

Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }, 
  routes: [
    {
      path: "/",
      name: "Startseite",
      component: Home,
    },
    {
      path: "/bio",
      name: "Bio",
      component: Bio,
    },
    {
      path: "/about",
      name: "About",
      component: About,
    },
    {
      path: "/kontakt",
      name: "Kontakt",
      component: Kontakt,
    },

    {
      path: "/leistungen",
      name: "Leistungen",
      component: Leistungen,
    },
        {
      path: "/methoden",
      name: "Methoden",
      component: Methoden,
    },
    {
      path: "/termine",
      name: "Termine",
      component: Termine,
    },
    {
      path: "/neuro",
      name: "Neuro-Athletik Training",
      component: Neuro,
    },
    {
      path: "/newsletter",
      name: "Newsletter",
      component: Newsletter,
    },
    {
      path: "/impressum",
      name: "Impressum",
      component: Impressum,
    },
    {
      path: "/agb",
      name: "Agb",
      component: Agb,
    },
        {
      path: "/teilnahmebedingungen",
      name: "Teilnahmebedingungen",
      component: Teilnahmebedingungen,
    },
    {
      path: "*",
      name: "Startseite",
      component: Home,
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js